<app-doug-shelf-talker-content
  [data]="data"
  [parentHeight]="parentHeight"
  [parentWidth]="parentWidth"
  [preview]="preview">
</app-doug-shelf-talker-content>
